import { Divider } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 800px;
`;

export const Header = styled.header`
  background-color: #fff;
  margin-bottom: 5px;
`;

export const Content = styled.div`
  background-color: #fff;
  flex-grow: 1;
  padding: 0 4px;
`;

export const StyledDivider = styled(Divider)`
  &.header-line {
    background-color: #4a4a4a;
    height: 2px;
  }
  &.sub-header-line {
    background-color: #696969;
    width: 98%;
    min-width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
`;
